export default function SellGoLogo({ size = 36, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 680 680"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="bgSellGo" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0F1F33" />
          <stop offset="100%" stopColor="#1E3A5F" />
        </linearGradient>
        <linearGradient id="pinSellGo" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="100%" stopColor="#E0F2FE" />
        </linearGradient>
      </defs>
      <rect x="40" y="40" width="600" height="600" rx="130" fill="url(#bgSellGo)" />
      <g transform="translate(165, 100)">
        <path
          d="M 175 0 C 78 0, 0 78, 0 175 C 0 320, 175 480, 175 480 C 175 480, 350 320, 350 175 C 350 78, 272 0, 175 0 Z"
          fill="url(#pinSellGo)"
        />
        <g transform="translate(85, 110)">
          <rect x="0" y="0" width="180" height="20" rx="4" fill="#1E3A5F" />
          <rect x="20" y="20" width="140" height="100" rx="6" fill="none" stroke="#1E3A5F" strokeWidth="8" />
          <circle cx="50" cy="145" r="14" fill="#1E3A5F" />
          <circle cx="130" cy="145" r="14" fill="#1E3A5F" />
          <rect x="40" y="50" width="20" height="55" rx="3" fill="#D85A4A" />
          <rect x="70" y="35" width="20" height="70" rx="3" fill="#D85A4A" />
          <rect x="100" y="20" width="20" height="85" rx="3" fill="#10B981" />
          <polyline points="50,75 80,55 110,40 130,30" stroke="#1E3A5F" strokeWidth="5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="130" cy="30" r="8" fill="#10B981" stroke="#1E3A5F" strokeWidth="3" />
        </g>
      </g>
    </svg>
  );
}